import { render, staticRenderFns } from "./GameReportTypeBody.vue?vue&type=template&id=64b6246e&"
import script from "./GameReportTypeBody.vue?vue&type=script&lang=ts&"
export * from "./GameReportTypeBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports